<section id="main-section">
    <app-common-loader *ngIf="loader"></app-common-loader>
    <div class="w-100 full-wdth-note-bookmarks">
        <div class="d-flex notes__bookmarks--banner">
            <div class="notes__bookmarks--banner-inner">
                <div>
                    <h3>
                        Share Post
                    </h3>
                    <p>Create your LinkedIn post with a caption to showcase your achievement.<br />You can add up to 4 images.</p>
                </div>
                <div>
                    <img src="./../../../../assets/images/upgradRed/upgradNandBLogo.png" alt="Notes and Bookmarks">
                </div>
            </div>
        </div>
        <article class="notes__bookmarks">
            <div *ngIf="!postUrlId" class="notes__bookmarks--wrap">
                <div class="profile-cont__form--group">
                    <input type="text" [(ngModel)]="caption" placeholder="Write Caption for post..." />
                </div>
                <div class="preview-image">
                    <div *ngFor="let image of localFiles; let i = index" class="image-container">
                        <img  [src]="image" alt="" />
                        <span class="material-symbols-outlined delete-image" (click)="deleteImage(i)" *ngIf="i != 0">
                            delete
                        </span>
                    </div>
                    <div class="custom-file-wrapper">
                        <label for="fileUpload" class="custom-file-label">
                            <span>Choose Images</span>
                          </label>
                        <input type="file" hidden #fileUpload id="fileUpload"  multiple  accept="image/*"  (change)="onFileSelect($event)" />
                    </div>
                </div>
                <div class="profile-cont__save">
                    <button type="submit" (click)="submitPost()" class="light-color link-no-underline red--button" [disabled]="!caption || !localFiles.length">Submit Post</button>
                </div>
            </div>
            <div *ngIf="postUrlId" class="notes__bookmarks--wrap">
                <p class="post-link">Your post is created. You can&nbsp;<a href="https://www.linkedin.com/feed/update/{{postUrlId}}" target="_blank">Click Here</a> &nbsp;here to check.</p>
            </div>
        </article>
    </div>
</section>